import { VpLoader } from '@vtmn-play/react/headless'
import { useTranslation } from 'react-i18next'
import { useMatch } from 'react-router'
import { Universes } from '@/components/Universes'
import { useUniverses } from '@/hooks/catalog'
import './catalog-offer-page.scss'

export function CatalogOfferPage() {
  const { t } = useTranslation()
  const exactSeasonMatch = useMatch('/:season')
  const deepSeasonMatch = useMatch('/:season/*')
  const currentSeason = (deepSeasonMatch ?? exactSeasonMatch)?.params?.season ?? ''

  const { universes, isLoading, isError } = useUniverses(currentSeason)

  return (
    <section className="catalog-offer-page" data-testid="offer-catalog_page">
      {isError && (
        <div className="error-container" data-testid="error-container">
          <p>{t('error.loading-universes')}</p>
        </div>
      )}
      {isLoading && !universes && (
        <div className="loader-container global">
          <VpLoader size="large" />
        </div>
      )}

      {!isError && universes && <Universes universes={universes} />}
    </section>
  )
}
